<template>
  <div class="organization-details">
    <div class="info-layout">
      <h3>
        Information
        <icon-button icon="el-icon-setting" v-if="!hideEdit" @click="$emit('edit')" />
      </h3>

      <div class="logo-container">
        <div class="organization-logo" :style="logoPath"></div>
      </div>

      <p>
        <span>
          {{ organization.email }} <br/>
        </span>
        E-mail
      </p>

      <p>
        <span>
          {{ organization.address }} <br/>
        </span>
        Address
      </p>

      <p>
        <span>
          {{ organization.zip }} <br/>
        </span>
        Zip
      </p>

      <p>
        <span>
          {{ organization.city }} <br/>
        </span>
        City
      </p>

      <p>
        <span>{{ organization.phoneNumber }}</span>
        Phone
      </p>

      <p>
        <span>{{ organization.country.name }}</span>
        Country
      </p>

      <station-map
          v-if="hideMap"
          style="margin: 20px 20px;"
          :stations="organization.stations"
          :map-only="true"
          height="250"
          :disableScrollZoom="true"/>
    </div>
  </div>
</template>

<script>
import StationMap from '@/components/dashboard/stations/map/StationMap'
import DivegasLogo from '@/assets/logo_all_blue.png'

export default {
  name: 'OrganizationDetails',
  components: { StationMap },
  props: {
    organization: {
      type: Object,
      required: true
    },
    center: {
      type: Boolean,
      required: false
    },
    hideEdit: {
      type: Boolean,
      required: false
    },
    hideMap: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    logoPath () {
      if (this.organization.logo) {
        return { backgroundImage: 'url(' + this.organization.logo.absolutePath + ')' }
      }

      return { backgroundImage: 'url(' + DivegasLogo + ')' }
    }
  }
}
</script>

<style lang="scss" scoped>

  .logo-container {
    padding: 15px 20px 20px 20px;

    @include breakpoint (xs) {
      padding-top: 0px;
    }
  }

  .organization-logo {
    width: 100%;
    height: 100px;
    background-size: auto 50px;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: white;
  }

  .center {
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/OrganizationDetails.vue